module.exports = __webpack_public_path__ + "img/ck3.58207846.png";